import { motion } from 'framer-motion'

interface Tab {
  id: string
  label: string
  sublabel?: string
}

interface TabGroupProps {
  tabs: Tab[]
  selected: string
  onChange: (id: string) => void
  className?: string
}

export function TabGroup({
  tabs,
  selected,
  onChange,
  className = '',
}: TabGroupProps) {
  return (
    <div className={`flex bg-gray-100 rounded-full p-1 ${className}`}>
      {tabs.map((tab) => (
        <button
          key={tab.id}
          onClick={() => onChange(tab.id)}
          className={`
            relative flex-1 py-3 px-4 text-sm font-medium rounded-full
            transition-colors duration-200
            ${selected === tab.id ? 'text-white' : 'text-gray-600 hover:text-gray-900'}
          `}
        >
          {selected === tab.id && (
            <motion.div
              layoutId="tab-indicator"
              className="absolute inset-0 bg-[#46C0C6] rounded-full"
              transition={{ type: 'spring', bounce: 0.2, duration: 0.6 }}
            />
          )}
          <span className="relative z-10 flex flex-col items-center">
            <span>{tab.label}</span>
            {tab.sublabel && (
              <span className={`text-xs mt-0.5 ${
                selected === tab.id ? 'text-white/80' : 'text-gray-400'
              }`}>
                {tab.sublabel}
              </span>
            )}
          </span>
        </button>
      ))}
    </div>
  )
}
